import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * CollabAuthRedirect - Handles legacy CollabAuth route
 * Redirects /CollabAuth?gid={token} to /comp-builder/job-builder/collaborator/{token}
 */
const CollabAuthRedirect: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Get token from query parameter (gid or token)
    const token = searchParams.get('gid') || searchParams.get('token');
    
    if (token) {
      // Redirect to the new collaborator route
      navigate(`/comp-builder/job-builder/collaborator/${token}`, { replace: true });
    } else {
      // No token provided, redirect to login with error
      navigate('/login?error=missing_token', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
};

export default CollabAuthRedirect;
